import { useEffect, useState } from 'react'
import { useMe } from '../lib/me.js'
import { useXanoRealtime } from '../lib/realtime.js'
import { onOpenChatDock, markChatDockOpen } from '../lib/chatDock.js'
import PatientChatDock from './patient/PatientChatDock.jsx'

/**
 * Renders the ข้อความ dock for a patient you are NOT currently looking at —
 * whoever a toast or the inbox list just pointed you at.
 *
 * Mounted once per layout. `skipPatientId` is the patient the page already owns a
 * dock for (PatientLayout): those requests are handled there instead, so the same
 * thread never opens twice on top of itself.
 *
 * It subscribes to that patient's `patient_update/{id}` while open so messages
 * arriving mid-read append live, exactly as they do on the patient page.
 */
export default function ChatDockHost({ skipPatientId = null }) {
  const me = useMe()
  const [req, setReq] = useState(null)
  const [live, setLive] = useState(null)

  useEffect(() => onOpenChatDock((r) => {
    if (skipPatientId != null && String(r.patientId) === String(skipPatientId)) return
    setLive(null)
    setReq(r)
  }), [skipPatientId])

  // Tells ChatToaster to stay quiet for this thread while it is on screen.
  useEffect(() => {
    if (!req?.patientId) return
    markChatDockOpen(req.patientId, true)
    return () => markChatDockOpen(req.patientId, false)
  }, [req?.patientId])

  useXanoRealtime(req?.patientId ? `patient_update/${req.patientId}` : null, (msg) => {
    const p = msg?.payload?.data ?? msg?.payload
    if (!p || typeof p !== 'object') return
    setLive({ ...p, at: Date.now() })
  })

  if (!req) return null

  return (
    <PatientChatDock
      patientId={req.patientId}
      patientName={req.patientName || ''}
      me={me}
      live={live}
      open
      onClose={() => setReq(null)}
    />
  )
}
